/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from './Globals';
import { qreq } from './qrequest';

const Auth = {
    getLogin(callback, errorCallback, force) {
        if (!force) {
            if (Globals.get('user')) {
                if (callback)
                    callback(Globals.get('user'));
                return;
            }
        }

        if (Auth.getLogin_process) {
            setTimeout(() => this.getLogin(callback, errorCallback, force), 100);
            return;
        }

        Auth.getLogin_process = true;

        qreq.get('/api/auth/current', j => {
            if (j.errorCode) {
                if (callback)
                    callback(null);
            }
            else {
                Globals.set('user', j.item);
                if (callback)
                    callback(j.item);
            }
            Auth.getLogin_process = false;
        }, e => {
            if (errorCallback)
                errorCallback(e);
            Auth.getLogin_process = false;
        });
    },

    isAdmin() {
        var u = Globals.get('user');
        if (!u)
            return false;
        if (u.flags.indexOf('admin') >= 0)
            return true;
        return false;
    },

    requireLogin(successCallback) {

        if (Globals.get('user')) {
            if (successCallback)
                successCallback(Globals.get('user'));
            return;
        }

        this.getLogin((user) => {
            if (user) {
                Globals.set('user', user);
                if (successCallback)
                    successCallback(user);
            }
            else
                document.location.assign('/');
        }, (e) => {
            document.location.assign('/error/connection');
        });
    },

    logout(noRedirect) {
        qreq.post('/api/auth/logout', j => {
            if (j.errorCode)
                alert(j.errorMessage);
            else {
                Globals.set('user', null);
                Globals.set('sid', null);
                if(!noRedirect)
                    document.location.assign('/');
            }
        });
    },

    hasFlag(role) {
        var user = Globals.get('user');
        if (!user || !user.flags)
            return false;

        var b = false;
        user.flags.forEach(i => {
            if (i === role)
                b = true;
        });
        return b;
    }
};

export default Auth;